import Header from "./Header";
import React from "react";
import {aboutUsList} from "../constants/Constants";
import banner from "../images/banner.png";

function AboutUs() {
    return (
        <div>
            <Header page="about"/>
            <div className="body">
                <div className={"heading"}>About Us</div>
                <img src={banner} alt="42Degrees Banner" className={"about-us-banner"}/>
                <div className={"about-us-list"}>
                {aboutUsList.map((item, index) => (
                    <div className={'about-us-entry'}>{item}</div>
                ))}
                </div>
            </div>
        </div>

    )
}

export default AboutUs;